import { Bleed, Card, Cell, colors, Grid, Row, Separator, Skeleton } from '@fs/zion-ui'
import React, { type ReactNode } from 'react'
import { css } from '@emotion/core'
import SectionHeading from './SectionHeading'
import useSourceCentricDetailsFlag from '../../../data-service/useSourceCentricDetailsFlag'

const expandableHeaderTitleHeightCss = css`
  height: 24px;
`

const separatorCss = css`
  height: 28px;
`

type Props = {
  isSingleCardPage?: boolean
  children?: ReactNode
  heading?: string
  /** Only for isSingleCardPage or isSourceCentric */
  headerEndElement?: ReactNode
}

export default function SectionCardSkeleton({
  isSingleCardPage,
  children,
  heading,
  headerEndElement,
}: Props): JSX.Element {
  const isSourceCentric = useSourceCentricDetailsFlag().data?.isOn
  const content = (
    <Card edges="border" backgroundColor={colors.gray00} margins="xs">
      <Bleed bottom>
        {isSingleCardPage || isSourceCentric ? (
          <Row alignY="middle" wrap>
            {heading ? <SectionHeading heading={heading} /> : <Skeleton.H5 maxWidth={200} />}
            {!!headerEndElement && <div growX />}
            {!!headerEndElement && <Cell>{headerEndElement}</Cell>}
          </Row>
        ) : (
          <div css={expandableHeaderTitleHeightCss}>
            {heading ? <SectionHeading heading={heading} /> : <Skeleton.H5 maxWidth={200} />}
          </div>
        )}
        {isSingleCardPage || isSourceCentric ? <Separator size="nano" /> : <div css={separatorCss} />}
        {children}
        <Separator size="nano" />
      </Bleed>
    </Card>
  )

  if (isSingleCardPage || isSourceCentric) {
    return <Grid gutters="none">{content}</Grid>
  }

  return content
}
